export const formatInvoiceSubject = (subject) => {
    if (!subject) return 'اصلی';
    
    const subjectMap = {
        'First': 'اصلی',
        'Second': 'اصلاح',
        'Third': 'ابطال',
        'Fourth': 'برگشت از فروش',
    };
    
    return subjectMap[subject] || subject;
};

export const parseInvoiceSubject = (subject) => {
    if (!subject) return 'First';
    
    const reverseMap = {
        'اصلی': 'First',
        'اصلاح': 'Second',
        'ابطال': 'Third',
        'برگشت از فروش': 'Fourth'
    };
    
    return reverseMap[subject] || subject;
};

